<template>
  <div>
    <div class="container-fluid heading" data-aos="fade-up">
      <heading :text="'Videos'"></heading>
    </div>
    <div class="row no-gutters item">
      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/9BlFtEbB-HA"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/dVEzMPQgaDQ"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/mvsdU6q4K4I"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <div class="row no-gutters">
      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/iBteZ-h6pMo"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/9Sj9_wfZX-A"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="video-wrapper">
          <iframe
            src="https://www.youtube.com/embed/n3Eo6M4VKCg"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VueCarousel"
};
</script>

<style lang="scss" scoped>
.video-wrapper {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  margin: 8px 8px 8px 8px;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid grey;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>
